/* export function getAddressData (state) {
  return state.addressData
} */
export function getTestimonials (state) {
  return state.testimonials
}
export function getFaq (state) {
  return state.faq
}
export function getPagination (state) {
  return state.pagination
}
export function getBreadcrumb (state) {
  return state.breadcrumb
}
export function getMeta (state) {
  return state.meta
}
export function getInternalLinks (state) {
  return state.internalLinks
}
export function getCountriesList (state) {
  return state.countries_list
}
